<template>
  
  <el-form label-width="120px" label-position="left" hide-required-asterisk @submit.native.prevent :model="form" ref="form">
    <el-form-item label="网站标题" prop="seo_title">
      <zt-input max-width="340px" v-model="form.seo_title"></zt-input>
      <p class="help">访问站点时在浏览器顶部显示的内容</p>
    </el-form-item>

    <el-form-item label="关键字" prop="seo_keyword">
      <zt-input max-width="340px" v-model="form.seo_keyword" disabled/>
      <p class="help">告知搜索引擎网站内容的主要特点，多个关键字以英文逗号分开</p>
    </el-form-item>

    <el-form-item label="网站描述" prop="seo_description">
      <zt-input max-width="340px" v-model="form.seo_description"></zt-input>
      <p class="help">告知搜索引擎网站的一些重要信息，简易描述在100字符以内</p>
    </el-form-item>

    <zt-button type="primary" @click.enter.exact="onSubmit" min-width="140px">保存</zt-button>
  </el-form>
</template>

<script>
import infoMixin from '../mixins/info'
export default {
  name: 'CMSWebSiteConfigSEO',
  mixins: [ infoMixin ],


  data: () => ({
    form: {
      seo_title: '',  // 网站标题
      seo_keyword: '',  // seo关键词
      seo_description: '',  // seo描述

      cms_member_allow_agent_apply: 1,
      cms_member_allow_agent_auto_join: 0,
      // 接口必传参数
      title: '',  // 网站标题
      domain: '', // 网站域名
      logo: '', // logo
      qq: '',
      wx: '', // 微信客服
      icpno: '',  // 备案信息
      cms_pid: '',  // cms pid
      tkl_pid: '',  // 淘口令 pid
      ssl: '',  // HTTPS域名
      cms_tksy: 0,
      // share_domain: '', // 分享域名
    },
  }),
}
</script>

<style lang="scss" scoped>
// @import "~@/styles/form.scss";
</style>